import { Carousel } from "react-bootstrap";
function ReviewPage() {
  const reviews = [
    {
      text: "Great place, people, and atmosphere was awesome. The guy that brought me to the back had me laughing the whole way.",
      name: "Jon C.",
      img: "https://randomuser.me/api/portraits/men/32.jpg",
    },
    {
      text: "Friendly staff and quick service. The facility was clean and the process was smooth from start to finish.",
      name: "Sarah M.",
      img: "https://randomuser.me/api/portraits/women/44.jpg",
    },
    {
      text: "Very professional and caring team. They made me feel at ease during my scan.",
      name: "David K.",
      img: "https://randomuser.me/api/portraits/men/65.jpg",
    },
  ];
  return (
    <>
      <div className="container text-center py-5 bg-muted    ">
        <div
          className="row"
          style={{
            backgroundColor: "#e7e8ef",
            borderRadius: "12px",
          }}
        >
          <h2 className="fw-bold text-primary-emphasis pt-5">
            Patient Reviews
          </h2>
          <div
            className="mx-auto my-0"
            style={{
              width: "150px",
              height: "5px",
              backgroundColor: "#FFD700",
            }}
          />
          <p
            className="text-primary-emphasis mb-3 mt-3"
            style={{ lineHeight: "1.6" }}
          >
            Our patients say it best. Rapid Lab Diagnostics provides welcoming,
            comforting outpatient facilities with friendly and helpful staff.
          </p>

          <Carousel
            indicators={false}
            controls={true}
            interval={null}
            touch={true}
            pause="hover"
            className="d-flex justify-content-center "
            style={{ minHeight: "430px" }}
          >
            {reviews.map((review, i) => (
              <Carousel.Item key={i}>
                <div className="d-flex justify-content-center">
                  <div
                    className="contact-bg p-5 text-white rounded"
                    style={{
                      maxWidth: "800px",
                    }}
                  >
                    <div className="mb-3 fs-4">
                      <span style={{ color: "#FFD700" }}>★★★★★</span>
                    </div>
                    <p className="mb-4" style={{ lineHeight: "1.5" }}>
                      {review.text}
                    </p>

                    <img
                      src={review.img}
                      alt="user"
                      loading="lazy"
                      className="rounded-circle mb-2"
                      style={{
                        width: "70px",
                        height: "70px",
                        objectFit: "cover",
                      }}
                    />
                    <h6 className="fw-bold">{review.name}</h6>
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </div>
    </>
  );
}

export default ReviewPage;
